import { ArsTableRow } from "../interface";
import { isArsTableBodyRow } from "./isArsTableBodyRow";
import { isArsTableHeaderRow } from "./isArsTableHeaderRow";

/**
 * Type guard for ArsTableRow, which can be either an ArsTableHeaderRow or an ArsTableBodyRow.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cells' displayContent and annotationContent
 * @returns - True if the object is an ArsTableRow, false otherwise
 */
export const isArsTableRow = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableRow => isArsTableHeaderRow(obj, isT) || isArsTableBodyRow(obj, isT);
